import { CarbonPolicyDatum } from "./CumulativeCarbonPolicyCostAggregator";

export function getCarbonPolicyData(buildings: BriefBuilding[]) {
    const carbonPolicyCostMap: { [key: string]: CarbonPolicyDatum } = {};
    buildings.forEach((building) => {
        building.baselineCrp?.carbonPolicyCosts.forEach((carbonPolicyCost) => {
            const key = getPolicyKey(building, carbonPolicyCost);
            if (!Object.prototype.hasOwnProperty.call(carbonPolicyCostMap, key)) {
                carbonPolicyCostMap[key] = initializeCarbonPolicyCostDatum(building, carbonPolicyCost, true);
            } else {
                carbonPolicyCostMap[key].baselineCost += carbonPolicyCost.cost;
            }
        });

        building.reportedCrp?.carbonPolicyCosts.forEach((carbonPolicyCost) => {
            const key = getPolicyKey(building, carbonPolicyCost);
            if (!Object.prototype.hasOwnProperty.call(carbonPolicyCostMap, key)) {
                carbonPolicyCostMap[key] = initializeCarbonPolicyCostDatum(building, carbonPolicyCost, false);
            } else {
                carbonPolicyCostMap[key].planCost += carbonPolicyCost.cost;
            }
        });
    });
    return Object.values(carbonPolicyCostMap);
}

function getPolicyKey(b: BriefBuilding, cpd: CarbonPolicyCost): string {
    return `${b.buildingModelUid}.${cpd.policyId}`;
}

function initializeCarbonPolicyCostDatum(
    building: BriefBuilding,
    carbonPolicyCost: CarbonPolicyCost,
    isBaseline: boolean
): CarbonPolicyDatum {
    let baselineCost: number = 0;
    let planCost: number = 0;
    if (isBaseline) {
        baselineCost = carbonPolicyCost.cost;
    } else {
        planCost = carbonPolicyCost.cost;
    }
    return {
        policyId: carbonPolicyCost.policyId,
        policyName: carbonPolicyCost.policyName,
        city: building.city,
        stateProvince: building.stateProvince,
        buildingArchetype: building.buildingArchetype,
        propertyName: building.propertyName,
        fundName: building.fundName,
        grossFloorArea: building.grossFloorArea,
        baselineCost,
        planCost,
    };
}
